<div class="tree-node" (click)="selectCategory()">
  <div class="set-title">
    <button mat-icon-button>
      <mat-icon svgIcon="folder-wrench"></mat-icon>
    </button>
    <span class="name">
      {{ node.label }}
    </span>
  </div>
</div>

<div class="sub-nodes">
  <mood-category-tree-node *ngFor="let subNode of childNodes" [node]="subNode"></mood-category-tree-node>
</div>
